// const e2p = (s: any) => s.replace(/\d/g, (d: any) => '۰۱۲۳۴۵۶۷۸۹'[d]);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const p2e = (s) => s.replace(/[۰-۹]/g, (d) => '۰۱۲۳۴۵۶۷۸۹'.indexOf(d));
export const convertToJalali = (date) => {
  const dt = date.toLocaleDateString('fa-IR', {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric'
  });
  return p2e(dt.replaceAll('/', '-'));
};

const JalaliDate = {
  g_days_in_month: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
  j_days_in_month: [31, 31, 31, 31, 31, 31, 30, 30, 30, 30, 30, 29]
};

JalaliDate.jalaliToGregorian = function (jY, jM, jD) {
  jY = parseInt(jY);
  jM = parseInt(jM);
  jD = parseInt(jD);
  const jy = jY - 979;
  const jm = jM - 1;
  const jd = jD - 1;

  let jDayNo = 365 * jy + parseInt(jy / 33) * 8 + parseInt(((jy % 33) + 3) / 4);
  for (let i = 0; i < jm; ++i) jDayNo += JalaliDate.j_days_in_month[i];

  jDayNo += jd;

  let gDayNo = jDayNo + 79;

  let gy =
    1600 + 400 * parseInt(gDayNo / 146097); /* 146097 = 365*400 + 400/4 - 400/100 + 400/400 */
  gDayNo = gDayNo % 146097;

  let leap = true;
  if (gDayNo >= 36525) {
    /* 36525 = 365*100 + 100/4 */
    gDayNo--;
    gy += 100 * parseInt(gDayNo / 36524); /* 36524 = 365*100 + 100/4 - 100/100 */
    gDayNo = gDayNo % 36524;

    if (gDayNo >= 365) gDayNo++;
    else leap = false;
  }

  gy += 4 * parseInt(gDayNo / 1461); /* 1461 = 365*4 + 4/4 */
  gDayNo %= 1461;

  if (gDayNo >= 366) {
    leap = false;

    gDayNo--;
    gy += parseInt(gDayNo / 365);
    gDayNo = gDayNo % 365;
  }
  let i = 0;
  for (i = 0; gDayNo >= JalaliDate.g_days_in_month[i] + (i === 1 && leap); i++) {
    gDayNo -= JalaliDate.g_days_in_month[i] + (i === 1 && leap);
  }
  let gm = i + 1;
  let gd = gDayNo + 1;

  gm = gm < 10 ? '0' + gm : gm;
  gd = gd < 10 ? '0' + gd : gd;

  return [gy, gm, gd];
};

export const convertJalaliTo = (myDate) => {
  const dateSplitted = myDate.split('-');
  const jD = JalaliDate.jalaliToGregorian(dateSplitted[0], dateSplitted[1], dateSplitted[2]);
  const jResult = jD[0] + '-' + jD[1] + '-' + jD[2];
  return jResult;
};
